import {lazy} from '@aboutyou/lazy-imports';

export const BrowserMemoryConsumptionTracker = lazy(() =>
  import('./BrowserMemoryConsumptionTracker.eager').then(mod => ({
    default: mod.BrowserMemoryConsumptionTracker,
  })),
);
